import type { PlayerAISuggestedPrompt } from "./playerai.types";

/**
 * Default suggested-prompt set for the PlayerAI rail. Keyed off the active
 * context label so the App and the Catalog stay visually identical.
 */
export function getDefaultPlayerAIPrompts(
  contextLabel?: string,
): PlayerAISuggestedPrompt[] {
  const ctx = contextLabel ?? "Home";
  if (ctx === "Home") {
    return [
      { id: "h1", label: "What needs my attention today?" },
      { id: "h2", label: "Summarize overnight changes" },
      { id: "h3", label: "Which KPIs are trending down?" },
    ];
  }
  if (ctx === "Launcher") {
    return [
      { id: "l1", label: "Which app should I open first?" },
      { id: "l2", label: "Where are most open actions?" },
    ];
  }
  return [
    { id: "a1", label: `Summarize current state of ${ctx}` },
    { id: "a2", label: `Top risks in ${ctx} this week` },
    { id: "a3", label: `Draft a next step for ${ctx}` },
  ];
}
